export default {
  install(Vue) {
    // Vue docs say to alter paramater Vue in plugin pattern
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$errorsIdString = (errors, fieldName) => {
      const errorIdStrings = errors.map((error, index) => `${fieldName}-error${index}`);
      return errorIdStrings.join(', ');
    };
  },
};
